export default {"src":"https://fishbrain.com/_next/static/media/wisconsin.56a59067.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};